module.exports = __webpack_public_path__ + "img/b.826e81b9.jpg";